<template lang="pug">
.preview-questionnaire-modal
  b-modal(v-model="_value" size="md" @ok="ok" title="プレビュー" no-close-on-backdrop no-close-on-esc)
    .preview-questionnaire-modal-body
      .questionnaire-title.mb-1(v-if="title") {{ title }}
      .questionnaire-text.mb-2(v-if="text")
        b-card(bg-variant="light")
          b-card-text
            .text(style="white-space: pre-wrap; word-break: break-all;") {{ text }}
      .mb-3(v-if="title || text")

      .question.mb-3(v-for="(question, index) in _questions")
        .question-header.d-flex.mb-2
          .question-title.mr-2 {{ question.title }}
          .question-require(v-if="question.required")
            b-badge(variant="danger") 必須

        .radios(v-if="getQuestionType(question) == 'radio'")
          .radio(v-for="option in question.options")
            b-form-radio(:name="'radio-' + index" :value="option.value") {{ option.text }}

        .checkboxs(v-if="getQuestionType(question) == 'checkbox'")
          .checkbox(v-for="option in question.options")
            b-form-checkbox {{ option.text }}

        .text(v-if="getQuestionType(question) == 'text'")
          b-form-input(placeholder="回答を入力してください")

        .textarea(v-if="getQuestionType(question) == 'textarea'")
          b-form-textarea(placeholder="回答を入力してください" rows="3" max-rows="6")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { QuestionnaireSelectItem, QuestionnaireTextItem, TemplateType } from "@/commons/services/Questionnaires";
import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionInputItemModel } from "./QuestionInputItem.vue";

/**
 * ### 文書送付、確認・同意ユーザー一覧モーダル
 */
@Component({})
export default class PreviewQuestionnaireModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** アンケートタイトル */
  @Prop()
  title!: string;
  /** アンケート本文 */
  @Prop()
  text!: string;
  /** 質問項目 */
  @Prop()
  questions!: Array<QuestionInputItemModel>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### answerの値を変えたくないのでコピーして使用する
   */
  get _questions(): Array<QuestionInputItemModel> {
    return Object.assign({}, this.questions);
  }

  /** ### 質問の種別を返す */
  getQuestionType(question: QuestionInputItemModel): QuestionType {
    // 選択肢
    if (question.type == TemplateType.SELECT) {
      const _question = question as unknown as QuestionnaireSelectItem;
      if (_question.multiple) {
        return QuestionType.CHECKBOX;
      } else {
        return QuestionType.RADIO;
      }
    }
    // テキスト入力
    else if (question.type == TemplateType.TEXT) {
      const _question = question as unknown as QuestionnaireTextItem;
      if (_question.isLong) {
        return QuestionType.TEXTAREA;
      } else {
        return QuestionType.TEXT;
      }
    }
    // その他
    else {
      return QuestionType.UNKNOWN;
    }
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}

export enum QuestionType {
  UNKNOWN = "unknown",
  RADIO = "radio",
  CHECKBOX = "checkbox",
  TEXT = "text",
  TEXTAREA = "textarea"
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.preview-questionnaire-modal-body {
  .questionnaire-title {
    font-weight: bold;
    font-size: 18px;
  }
  .question-title {
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
